<header class="text-center flex-row-center py-2 px-3">
  <a routerLink="/">
    <img style="height: 50px" class="img-fluid" src="assets/images/logo.webp">
  </a>
</header>
